import { FC } from 'react'
import { InnerAccordions } from './InnerAccordions'
import { InnerMap } from './InnerMap'

interface PrefectureLinksProps {
  choiceCode?: string
}

export const PrefectureLinks: FC<PrefectureLinksProps> = (props) => {
  return (
    <>
      <InnerAccordions {...props} />
      <InnerMap {...props} />
    </>
  )
}
